<template>
  <el-dialog :title="titleList[popType]" :visible.sync="formVisible" width="800px" :close-on-click-modal="false" v-if="formVisible">
    <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="100px">
      <el-form-item label="客户：" prop="customerId" class="width100">
        <el-select v-model="form.customerId" placeholder="请选择充值客户" filterable remote clearable size="mini" :remote-method="searchUsers" :loading="loading">
          <el-option :label="`${item.name} (${item.pho})(${item.levelName})(${item.cityCompanyName})`" :value="item.id" v-for="(item,index) in customers" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="赠送活动：" prop="rewardType" class="width100">
        <div class="reward-type">
          <el-select v-model="form.rewardType" filterable placeholder="请选择奖励类型" clearable size="mini">
            <el-option label="商品" :value="2"></el-option>
            <el-option label="零售价" :value="1"></el-option>
          </el-select>
          <el-select v-model="form.rewardGoodsId" filterable placeholder="请选择商品" clearable size="mini" @change="handleChange()" v-if="form.rewardType==2">
            <el-option :label="item.name" :value="item.id" v-for="(item,index) in goodsList" :key="index"></el-option>
          </el-select>
          <span v-if="form.rewardType==2 && goodsSkuList.length === 1" class="spec-text">{{ goodsSkuList[0].spec || '无规格值' }}</span>
          <el-select v-else v-model="form.skuId" filterable placeholder="请选择规格" clearable size="mini" v-if="form.rewardType==2">
            <el-option :label="item.spec || '无规格值'" :value="item.id" v-for="(item,index) in goodsSkuList" :key="index" :disabled="!form.rewardGoodsId"></el-option>
          </el-select>
          <el-input v-model="form.xiaoduMoney" placeholder="请输入零售价" v-if="form.rewardType==1"></el-input>
          <el-select disabled placeholder="请选择奖励" clearable size="mini" v-if="!form.rewardType"></el-select>
        </div>
      </el-form-item>
      <!-- <el-form-item label="收款银行" prop="bankName" class="width100">
        <el-select v-model="form.bankName" placeholder="请选择收款银行">
          <el-option :label="item.bankName" :value="item.bankName" v-for="(item,index) in configList" :key="index"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="付款凭证：" prop="payVoucherUrl" class="width100">
        <div class="upload-box flexs">
          <div class="upload-img">
            <image-upload v-model="form.payVoucherUrl" :aliCloud="true" :width="80" :height="80" @input="handleSuccess" />
            <!-- <el-upload :action="uploadUrl" list-type="picture-card" :multiple="false" limit="1" :on-success="handleSuccess" :on-remove="handleRemove">
              <i class="el-icon-plus"></i>
            </el-upload> -->
          </div>
          <div class="upload-input">
            <div class="item" v-for="(item,index) in form.payOrderNums" :key="index">
              <el-button type="primary" @click="getOcrTest(index)" v-if="item.ocrContent==''" style="width: 120px;">通过OCR提取文字</el-button>
              <el-popover v-else placement="top-start" title="" width="400" trigger="hover" :content="item.ocrContent">
                <el-button slot="reference">查看OCR提取的信息</el-button>
              </el-popover>
              <div style="display: flex;align-items: center;">
          <el-form-item :prop="'payOrderNums.' + index + '.payBank'" :rules="{ required: true, message: '请选择收款银行', trigger: 'change' }" class="cus-sty">
                  <el-select v-model="item.payBank" placeholder="请选择收款银行" filterable>
                    <el-option :label="it.bankName" :value="it.bankName" v-for="(it,idx) in visibleBankOptions" :key="idx"></el-option>
                  </el-select>
                </el-form-item>
                <el-button type="text" @click="toggleBankFilter" style="margin-left: 6px;">
                  {{ showAllBanks ? '按城市过滤' : '显示全部' }}
                </el-button>
                <el-form-item :prop="'payOrderNums.' + index + '.payNum'" :rules="{ required: true, message: '请输入支付单号', trigger: 'blur' }" class="cus-sty">
                  <el-input v-model="item.payNum" placeholder="请输入支付单号"></el-input>
                </el-form-item>
              </div>
              <div style="display: flex;align-items: center;">
                <el-form-item :prop="'payOrderNums.' + index + '.payMoney'" :rules="{ required: true, message: '请输入付款金额', trigger: 'blur' }" class="cus-sty">
                  <el-input v-model="item.payMoney" placeholder="请输入付款金额" @input="handlePayMoneyChange"></el-input>
                </el-form-item>
                <el-form-item :prop="'payOrderNums.' + index + '.payTime'" :rules="{ required: true, message: '请选择付款日期', trigger: 'change' }" class="cus-sty">
                  <el-date-picker v-model="item.payTime" size="small" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="付款日期"></el-date-picker>
                </el-form-item>
              </div>
              <div style="display: flex;align-items: center;">
                <el-form-item :prop="'payOrderNums.' + index + '.payMethod'" :rules="{ required: true, message: '请选择付款方式', trigger: 'change' }" class="cus-sty">
                  <el-select v-model="item.payMethod" placeholder="请选择付款方式">
                    <el-option label="扫码支付" :value="1"></el-option>
                    <el-option label="银行转账" :value="2"></el-option>
                  </el-select>
                </el-form-item>
              </div>
              <!-- <el-input v-model="item.payNum" placeholder="请输入支付单号"></el-input> -->
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="充值金额：" prop="orderAmount" class="width100">
        <el-input v-model="form.orderAmount" placeholder="请输入充值金额" disabled>
          <span slot="suffix" style="margin-right: 5px;">元</span>
        </el-input>
      </el-form-item>
      <el-form-item label="备注：" prop="orderNote" class="width100">
        <el-input v-model="form.orderNote" placeholder="请输入赠送原因" maxlength="50" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="充值类型：" prop="rechargeType" class="width100">
        <el-select v-model="form.rechargeType" placeholder="请选择充值类型" clearable size="small">
          <el-option 
            v-for="(item, index) in rechargeTypeOptions" 
            :key="index" 
            :label="item" 
            :value="item">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">
        取消
      </el-button>
      <el-button type="primary" @click="doCreate()" :loading="isLoading">
        确认
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import rechargeRecordApi from '@/api/recharge/rechargeRecord'
import sysGoodsApi from '@/api/goods/sysGoods'
import clientListApi from '@/api/client/clientList'
import sysDataconstantApi from '@/api/config/sysDataconstant'
import managecustomerwalletApi from '@/api/cust/managecustomerwallet'
import ImageUpload from "@/components/ImageUpload";
function initFormBean() {
  const formBean = {
    payType: 3,
    orderType: 2,
    dataSource: 5,
    customerId: '',
    orderAmount: '',
    rewardType: '',
    payOrderNum: '',
    payVoucherUrl: '',
    xiaoduMoney: '',
    rewardGoodsId: '',
    orderNote: '',
    skuId: '',
    payOrderNums: [],
    rechargeType: '' // 充值类型
  }
  return formBean
}

export default {
  props: ['popType'],
  components: {
    ImageUpload
  },
  watch: {
    'form.customerId': {
      handler() {
        // 客户切换时，若当前值不在过滤列表中则清空
        this.$nextTick(() => {
          if (this.form.payOrderNums && this.form.payOrderNums.length > 0) {
            const first = this.form.payOrderNums[0]
            if (first && first.payBank) {
              const exists = this.filteredConfigList.some(it => it.bankName === first.payBank)
              if (!exists) first.payBank = ''
            }
          }
        })
      },
      immediate: true
    }
  },
  //popType 0:新增
  data() {
    return {
      uploadUrl: process.env.VUE_APP_BASE_API + '/sys/cosUploader/upload',
      titleList: ['赠送额度'],
      form: initFormBean(),
      formVisible: false,
      formRules: {
        orderAmount: [{ required: true, message: '请输入充值金额', trigger: 'blur' }],
        payVoucherUrl: [{ required: true, message: '请选择付款凭证', trigger: 'change' }],
        customerId: [{ required: true, message: '请选择客户', trigger: 'change' }],
        rechargeType: [{ required: true, message: '请选择充值类型', trigger: 'change' }],
      },
      queryGoods: {
        pageNo: 1,
        pageSize: 1000
      },
      queryCustomer: {
        pageNo: 1,
        pageSize: 100
      },
      goodsList: [],
      customers: [],
      uploadImgs: [],
      // payOrderNums: [],
      configList: [],
      goodsSkuList: [],
      isLoading: false,
      showAllBanks: false,
      loading: false,
      rechargeTypeOptions: [] // 充值类型选项
    }
  },
  computed: {
    filteredConfigList() {
      // 仅显示已启用的银行
      const enabled = this.configList.filter(it => String(it.isEnable) === '1')
      const selected = this.customers.find(it => it.id === this.form.customerId)
      const selectedCityCompanyId = selected && selected.cityCompanyId

      // 仅按城市公司ID进行过滤（银行 cityId 与 客户 cityCompanyId 匹配）
      if (selectedCityCompanyId !== undefined && selectedCityCompanyId !== null && selectedCityCompanyId !== '') {
        const ccIdNum = Number(selectedCityCompanyId)
        return enabled.filter(it => Number(it.cityId) === ccIdNum)
      }

      // 未选择客户时，返回全部启用银行
      return enabled
    },
    visibleBankOptions() {
      return this.showAllBanks ? this.configList.filter(it => String(it.isEnable) === '1') : this.filteredConfigList
    }
  },
  created() {
    this.getCustomer();
    this.getConfig();
    this.getRechargeTypeOptions();
  },
  methods: {
    toggleBankFilter() {
      this.showAllBanks = !this.showAllBanks
    },
    calculateTotalAmount() {
      if (this.form.payOrderNums && this.form.payOrderNums.length > 0) {
        const total = this.form.payOrderNums.reduce((sum, item) => {
          const amount = parseFloat(item.payMoney) || 0;
          return sum + amount;
        }, 0);
        this.form.orderAmount = total.toFixed(2);
      }
    },
    handlePayMoneyChange() {
      this.calculateTotalAmount();
    },
    handleChange() {
      let find = this.goodsList.find(it => it.id === this.form.rewardGoodsId)
      this.goodsSkuList = find.specValueList;
      if (this.goodsSkuList && this.goodsSkuList.length === 1) {
        this.$set(this.form, 'skuId', this.goodsSkuList[0].id)
      } else {
        this.$set(this.form, 'skuId', null)
      }
    },
    getConfig() {
      sysDataconstantApi.fetchBatchCode({ code: 'lineUpMoneyBankType' }).then(({ data }) => {
        this.configList = data.list[0].content ? JSON.parse(data.list[0].content) : []
      })
    },
    /**
     * 获取充值类型选项
     */
    getRechargeTypeOptions() {
      sysDataconstantApi.fetchBatchCode({ code: 'chongZhiLeiXingPeiZhi' })
        .then(({ data }) => {
          const find = data.list.find(item => item.code === 'chongZhiLeiXingPeiZhi')
          if (find && find.content) {
            this.rechargeTypeOptions = find.content.split(',').filter(item => item.trim())
          }
      })
    },
    /**
     * 获取客户列表
     */
    getCustomer(e) {
      let query = {
        pageNo: 1,
        pageSize: 100,
        type: 1
      }
      if (e) {
        query.name = e
      }
      managecustomerwalletApi.findAreaCustomerList(query)
        .then(res => {
          this.customers = res.data;
        })
    },
    searchUsers(query) {
      if (query !== '') {
        this.loading = true;
        // 模拟远程搜索，实际应用中应该是发起AJAX请求
        setTimeout(() => {
          this.loading = false;
          this.getCustomer(query)
        }, 500);
      } else {
        this.customers = [];
      }
    },
    /**
     * 获取商品列表
     */
    getGoodsList() {
      // sysDataconstantApi.fetchBatchCode({ code: 'orderAndTopupSendBook' }).then(({ data }) => {
      //   let code = data.list && data.list[0].content
      //   sysGoodsApi.fetchByCode(code).then(res => {
      //     this.goodsList = res.data
      //   });
      // })
      sysGoodsApi.getGoodRecomList().then(res => {
        this.goodsList = res.data
      });
    },
    /**
     * 重置表单
     */
    resetForm() {
      this.form.pageNo = 1;
      // this.payOrderNums = []
      this.uploadImgs = []
      this.form = initFormBean()
      if (!this.goodsList.length) this.getGoodsList();
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.resetForm()
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(data) {
      this.resetForm()
      this.form = { ...data.row }
      if (this.form.rewardType == 3) this.form.rewardType = '';
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    /**
     * 提交表单
     */
    doCreate() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          if (this.form.payOrderNums.length) {
            this.form.payOrderNums.forEach(item => {
              item.dataType = 2
              item.state = 1
            })
            this.form.addList = this.form.payOrderNums
          }
          if (this.form.rewardType == 2) {
            this.form.xiaoduMoney = null;
          } else if (this.form.rewardType == 1) {
            this.form.goodsId = null;
          } else {
            this.form.xiaoduMoney = this.form.goodsId = null;
          }
          let params = { ...this.form };
          params.bankName = this.form.payOrderNums[0].payBank
          params.payMethod = this.form.payOrderNums[0].payMethod
          // 2026-03-03版本号是2，提交的记录需要上级审核
          params.version=2
          delete params.payOrderNums
          if (this.form.rewardType == '') params.rewardType = 3;
          this.isLoading = true
          if (this.form.id > 0) {
            rechargeRecordApi.update(params).then((data) => {
              this.postCallback(data)
            }).catch(() => {
              this.isLoading = false
            })
          } else {
            rechargeRecordApi.create(params).then((data) => {
              this.postCallback(data)
            }).catch(() => {
              this.isLoading = false
            })
          }
        }
      });
    },
    /**
     * 回调
     */
    postCallback(response) {
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
      this.isLoading = false
    },
    /**
     * 上传成功
     */
    handleSuccess(url) {
      if (url) {
        this.uploadImgs = [url]
        this.form.payVoucherUrl = this.uploadImgs.join(',')
        let obj = {
          ocrContent: '',
          payNum: '',
          payBank: '',
          payMoney: '',
          payTime: '',
          payImg: url,
          payMethod: null
        }
        if (this.form.payOrderNums.length == 0) this.$set(this.form, 'payOrderNums', [obj])
        else this.$set(this.form.payOrderNums[0], 'payImg', url)
        // 上传后不再自动填充银行，由操作人员从过滤后的下拉中选择
      } else {
        this.uploadImgs = []
      }
    },
    /**
     * 删除成功
     */
    handleRemove(file, fileList) {
      let index = this.uploadImgs.findIndex(item => item == file.response.data)
      this.uploadImgs.splice(index, 1)
      this.payOrderNums.splice(index, 1)
    },
    /**
     * 识别支付单号
     */
    getOcrTest(index) {
      return rechargeRecordApi.accurateOCR({ imageUrl: this.uploadImgs[index] })
        .then(res => {
          this.form.payOrderNums[index].ocrContent = res.data
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.el-form-item--small.el-form-item.cus-sty {
  width: 220px;
  margin-bottom: 2px;
  margin-right: 2px;
}
.el-form-item--small.el-form-item {
  width: 48%;
  display: inline-block;
  vertical-align: top;
}
.reward-type {
  display: flex;
  & > .el-select {
    &:first-child {
      width: 180px;
      margin-right: 10px;
    }
  }
}
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
.upload-box {
  align-items: flex-start;
  .upload-img {
    width: 80px;
  }
  .upload-input {
    width: calc(100% - 80px);
    .item {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      min-height: 70px;
      margin-bottom: 10px;
    }
  }
}

::v-deep .el-select {
  width: 100%;
}
::v-deep .el-cascader {
  width: 100%;
}
::v-deep .el-upload-list__item,
::v-deep .el-upload--picture-card {
  width: 70px;
  height: 70px;
  line-height: 75px;
  margin-bottom: 35px;
}
::v-deep .el-upload--picture-card:last-child {
  margin-bottom: 0;
}
::v-deep .el-upload-list__item.is-success .el-upload-list__item-status-label {
  display: none;
}
::v-deep .hide-upload .el-upload {
  display: none;
}
</style>
